import { ModalEnum } from "myParkdUtils/enums";


export const MODAL_WINDOW_UPDATE = 'MODAL_WINDOW_UPDATE';


export const updateModalWindow = (modalName: ModalEnum, modalData?: any) => {
    return {
        type: MODAL_WINDOW_UPDATE,
        payload: { modalName, modalData }
    };
};

export const closeModal = () => {
    return {
        type: MODAL_WINDOW_UPDATE,
        payload: { modalName: null, modalData: null }
    };
};

// todo: generate Action types dynamically
export type ModalWindowAction = {
    type: 'MODAL_WINDOW_UPDATE',
    payload: {
        modalName: ModalEnum,
        modalData: any
    }
}
